export default __webpack_public_path__ + "static/media/custom2.2f5cfda7.jpg";